import { useEffect, useState } from "react";
import Head from "next/head";
import Image from "next/image";

import Typography from "@mui/material/Typography";
import { ThemeProvider } from "@mui/material/styles";
import { Modal } from "@mui/material";
import Box from "@mui/material/Box";

import { setCookies, getCookie } from "cookies-next";

import fonts from "../styles/FontInter.module.css";
import mainTheme from "../components/mainTheme";
import styles from "../styles/Home.module.css";
import ExitIntent from "../lib/ExitIntent";

const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "600px",
    height: "calc((95vw * .5625) + 10)",
    maxWidth: "95vw",
    bgcolor: "background.paper",
    boxShadow: 24,
  };

export default function ExitModal({ cookieSkip, modalSkip, children }) {
    const [showPopup, setShowPopup] = useState(false)
    
    if(showPopup && !cookieSkip){
        let expiryDate = new Date(
            Date.now() + 14 * (1000 * 60 * 60 * 24)
          )
        expiryDate.setFullYear(expiryDate.getFullYear() + 1)
        setCookies('elmexitexpire', 'true', { maxAge: 14 * 60 * 60 * 24});
    }

    useEffect(() => {
        
        dataLayer.push({ event: "optimize.activate" });
        let cookie = getCookie("elmexitexpire");
        
        const removeExitIntent = ExitIntent({
            threshold: 20,
            eventThrottle: 100,
            onExitIntent: () => {
                if(modalSkip != true){
                    if(!cookie || (cookie && cookie != true) || cookieSkip){
                        setShowPopup(true)
                    }
                }
            },
            })
        return () => {
            removeExitIntent()
            }
    }, []);

    const handleClose = () => setShowPopup(false);
  

    return (
        <ThemeProvider theme={mainTheme}>
            <Modal
            open={showPopup}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            >
                           
            <Box sx={modalStyle} style={{outline:"none"}}>
                <div onClick={handleClose}style={{position: "absolute",right: "0", top: "-24px"}}>
                    <a style={{color:"white",fontWeight:"700",cursor:"pointer"}}>X</a>
                </div> 
                {children}
            </Box>
            </Modal>
        </ThemeProvider>
    );
}